module.exports = {
  name: 'en-US',
  months: ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],
  monthsShort: ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'],
  days: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
  daysShort: ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa'],
  thousandSeparator: ' ',
  decimalSeparator: '.',
  formats: {
    'General Number': '#.#',
    'Currency': '$ #,##0.00;[Red]$ -#,##0.00',
    'Fixed': '0.00',
    'Standard': '#,##0.00',
    'Percent': '0.00%',
    'Scientific': '0.00E+00',
    'Yes/No': '"Yes";"Yes";"No"',
    'True/False': '"True";"True";"False"',
    'On/Off': '"On";"On";"Off"',
    'Short Date': 'mm.dd.yyyy',
    'Long Date': 'dd mmmm yyyy',
    'General Date': 'mm.dd.yyyy h:mm',
    'Medium Date': 'dd.mmm.yy',
    'Long Time': 'hh:mm:ss AM/PM',
    'Short Time': 'h:mm',
    'Medium Time': 'hh:mm AM/PM'
  }
};



// WEBPACK FOOTER //
// ./src/locales/en-US.js